/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 11:33:30
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-30 13:48:03
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\store\stateTypes.js
 */
/* ----base---- */
export const RESEARCHRAUTHORITY = 'RESEARCHRAUTHORITY'// 研究权限
export const IDENTITYTYPE = 'IDENTITYTYPE'// 角色类型
/* ----research----- */
export const RESEARCHNAME = 'RESEARCHNAME'// 研究名称
export const RESEARCHCODE = 'RESEARCHCODE'// 研究code
export const RESEARCHINFO = 'RESEARCHINFO'// 研究信息
/* ----testee----- */
export const TESTEEDETAIL = 'TESTEEDETAIL'// 受试者详情
export const TESTEEFORM = 'TESTEEFORM' // 受试者表单
/* ----center----- */
export const CENTERNAME = 'CENTERNAME' // 受试者表单
/* ----recruit---- */
export const RECRUITFORM = 'RECRUITFORM' // 招募表单
